import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../server";
import { Button, DatePicker, message, Table, Card, Typography, Spin } from "antd";
import dayjs from "dayjs";
import { fmtDate, strDate2Server } from "../../extensions/utils";
import StockCard from "./stock-card";
import "./stock.css"
import { exportExcel } from "../../extensions/export-excel";
import "../../controls/print-page/print-page.css"
import ButtonReport from "../../controls/button-report/button-report";
import { ExportExcelButton, HelpButton, PrintButton } from "../../extensions/design";
import { isMobile, menuSize } from "../../extensions/design";
import { useLocalStorageFilter, applyDateRoll } from "@/extensions/use-local-storage-filter";
const { Text } = Typography;

const StockOsv = () => {
  const [loading, setLoading] = useState(false);
  
  // Инициализация фильтра из localStorage или значения по умолчанию
  const [filter, setFilter] = useLocalStorageFilter(
    'stockOsv',
    () => ({ dateFrom: dayjs().startOf('month'), dateTo: dayjs(), storeId: null }),
    (parsed) => {
      const { dateFrom, dateTo } = applyDateRoll(
        parsed.dateTo ? dayjs(parsed.dateTo) : null,
        dayjs().startOf('month'),
        dayjs(),
        parsed.dateFrom ? dayjs(parsed.dateFrom) : null,
      );
      return {
        dateFrom: dateFrom,
        dateTo: dateTo,
        storeId: parsed.storeId || null,
      };
    },
    (filter) => ({
      dateFrom: filter.dateFrom?.format('YYYY-MM-DD'),
      dateTo: filter.dateTo?.format('YYYY-MM-DD'),
      storeId: filter.storeId,
    }),
  );
  const [items, setItems] = useState([]);
  const [display, setDisplay] = useState({dateFrom: dayjs(), dateTo: dayjs(), storeId: null});
  const divRef = useRef(null);
  const [item, setItem] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);

  const getData = (f = filter) => {
    setLoading(true);
    serverFetch(`report/BalanceSheet?dateFrom=${strDate2Server(f.dateFrom)}&dateTo=${strDate2Server(f.dateTo)}`)
      .then(data => {
        setItems(data.sort((a, b) => a.productName.localeCompare(b.productName)));
        setLoading(false);
        setDisplay({...f});
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(() => {
    getData(filter);
  }, []);

  const handlePrint = () => {
    setIsPrinting(true);
    setTimeout(() => {
      window.print();
      setIsPrinting(false);
    }, 500);
  };

  const handleExportExcel = () => {
    exportExcel(items, columns, "ОСВ.xlsx");
  };

  const columns = [
    { dataIndex: "productId", title: "#", },
    { dataIndex: "productName", title: "Товар", width: 400 },
    { dataIndex: "productUnit", title: "Единица", },
    { dataIndex: "qtyBegin", title: fmtDate(display.dateFrom), align: "right" },
    { dataIndex: "qtyPut", title: "Приход", align: "right" },
    { dataIndex: "qtyExp", title: "Расход", align: "right" },
    { dataIndex: "qtyTransfer", title: "Передано", align: "right" },
    { dataIndex: "qtyEnd", title: fmtDate(display.dateTo), align: "right" },
  ]

  const headerSize =  divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) || 0;

  const onChangeFilter = value => {
    const newFilter = { ...filter, ...value };
    setFilter(newFilter);
    if (isMobile) {
      getData(newFilter);
    }
  };

  const onClose = refresh => {
    setItem(null);
    refresh && getData(filter);
  }

  return !isMobile ? (<div>
    <div className="sport-form-title">
      <div>Период с</div>
      <DatePicker value={filter.dateFrom} format="DD.MM.YYYY" onChange={e => onChangeFilter({ dateFrom: e })} allowClear={false}/>
      <div>по</div>
      <DatePicker value={filter.dateTo} format="DD.MM.YYYY" onChange={e => onChangeFilter({ dateTo: e })} allowClear={false}/>
      <Button onClick={() => getData(filter)}>Обновить</Button>
      <PrintButton onClick={handlePrint} />
      <ExportExcelButton onClick={handleExportExcel} />
      <ButtonReport id={0} vid={6} begPer={filter.dateFrom} endPer={filter.dateTo} />
      <HelpButton article="tekuschie-ostatki-dvizhenie-tovarov"/>
    </div>
    <div ref={divRef} style={{width: tableWidth}}>
      <div className="print-area table-print-fullwidth">
        <Table dataSource={items} loading={loading} columns={columns} pagination={false} size="small" rowKey="productId"
        scroll={isPrinting ? undefined : { y: tableHeight }} sticky={!isPrinting}
          onRow={(record) => {return {onClick: () => {setItem(record)}}} }
        />
      </div>
      {item && <StockCard
        id={item.productId}
        begPeriod={display.dateFrom}
        endPeriod={display.dateTo}
        productName={item.productName}
        productUnit={item.productUnit}
        onClose={onClose}
      />}
    </div>
  </div>) : loading ? (
      <div className="report-loading">
        <Spin size="large" />
      </div>
    ) : (
    <>
      <div style={{display:"flex", justifyContent: "space-around", alignItems:"center"}}>
        <Text>Период с </Text>
        <DatePicker className="record-date-picker-mobile" value={filter.dateFrom} format="DD.MM.YYYY" onChange={e => onChangeFilter({ dateFrom: e })} allowClear={false}/>
        <Text> по </Text>
        <DatePicker className="record-date-picker-mobile" value={filter.dateTo} format="DD.MM.YYYY" onChange={e => onChangeFilter({ dateTo: e })} allowClear={false}/>
      </div>
      <div className="stock-scrollable-list" style={{ height: window.innerHeight - menuSize - 32}}>
        {items.map(item => {
          return (
          <Card key={item.productId} className="stock-card" style={{ borderLeft: "4px solid #d9d9d9" }} onClick={() => setItem(item)}>
            <div className="stock-osv-item-line-long-and-short">
              <Text className="client-item-clip" strong> {item.productName} </Text> <Text className="client-item-clip-right"> #{item.productId} </Text>
            </div>
            <div className="stock-osv-item-line-triple">
              <div>
                <Text>Приход: </Text> <Text strong> {item.qtyPut}</Text>
              </div>
              <div style={{textAlign: "center"}}>
                <Text>Расход: </Text> <Text strong> {item.qtyExp}</Text>
              </div>
              <div style={{textAlign: "right"}}>
                <Text>Передано: </Text> <Text strong> {item.qtyTransfer}</Text>
              </div>
            </div>
            <div className="stock-osv-item-line-double">
              <div>
                <Text> На {fmtDate(display.dateFrom)}: </Text> <Text strong> {item.qtyBegin} {item.productUnit} </Text>
              </div>
              <div style={{textAlign: "right"}}>
                <Text> На {fmtDate(display.dateTo)}: </Text> <Text strong> {item.qtyEnd} {item.productUnit} </Text>
              </div>
            </div>
          </Card>
        )})}
        {(items.length === 0 && !loading) ?
        <div className="stock-no-data-text">Нет данных
        </div> : <></>}
      </div>
      {item && <StockCard
        id={item.productId}
        begPeriod={display.dateFrom}
        endPeriod={display.dateTo}
        productName={item.productName}
        productUnit={item.productUnit}
        onClose={onClose}
      />}
    </>
  )
}

export default StockOsv;